import React from 'react';
import { BaseLinkProps } from './BaseLink';
import { getLinkColor, getLinkFontFamily } from './helpers';
import { StyledHeadingLink } from './StyledHeadingLink';

export type HeadingLinkProps = Omit<BaseLinkProps, 'size'>;

export function HeadingLink({
    children,
    color = 'puntRoad',
    fontFamily = 'heading',
    ...props
}: HeadingLinkProps) {
    return (
        <StyledHeadingLink
            {...props}
            linkColor={getLinkColor(color)}
            linkFontFamily={getLinkFontFamily(fontFamily)}
        >
            {children}
        </StyledHeadingLink>
    );
}
